
import { Component, Vue, Watch } from 'vue-property-decorator'
import Navbar from '@/components/shared/navbar.vue'
import {
  getPatients,
  postPatient,
  updatePatientStatus,
  updatePatient
} from '@/components/patients/patients.service'
import {
  InsuranceIPANumber,
  PaginationVM,
  Patient,
  PatientVM,
  Role,
  SelectVM,
  UpdatePatientStatus
} from '@/models'
import moment from 'moment'
import {
  getCurrentUser,
  getDoctorHeadId,
  getHeadDoctor,
  getUserRole,
  getUserRmtId
} from '@/components/admin/users/users.service'
import Multiselect from 'vue-multiselect'
import {
  getIPANumbers,
  getInsuranceAgreementsResolve
} from '@/components/insurances/insurance.service'
import {
  getDoctorInsurances,
  getInsuranceSupervisorInsurances,
  getUserInsurances
} from '@/components/doctors/doctors.service'
import {
  XlsxRead,
  XlsxSheets,
  XlsxJson,
  XlsxWorkbook,
  XlsxSheet,
  XlsxDownload
} from 'vue-xlsx'
import XLSX from 'xlsx'

import { BTable } from 'bootstrap-vue'
import xlsx from 'json-as-xlsx'
import { namespace } from 'vuex-class'

const AppModule = namespace('app')

@Component({
  components: {
    Navbar,
    Multiselect,
    XlsxRead,
    XlsxSheets,
    XlsxJson,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    FileReader,
    XLSX
  }
})
export default class PatientsView extends Vue {
  @AppModule.Getter
  public _getUserInsurancesID!: number[]

  public insuranceList: SelectVM[] = []

  public fields = [
    // 'index',
    {
      key: 'index',
      label: '#',
      sortable: true,
      order: 1
    },
    {
      key: 'npi',
      label: 'NPI',
      sortable: true,
      order: 2
    },
    {
      key: 'doctorFullName',
      label: 'Doctor Name',
      sortable: true,
      order: 3
    },
    // {
    //   key: 'documentID',
    //   label: 'Document ID',
    //   sortable: true
    // },
    {
      key: 'fullName',
      label: 'Patient Name',
      sortable: true,
      order: 4
    },

    {
      key: 'insuranceName',
      label: 'Insurance',
      sortable: true,
      order: 5
    },
    {
      key: 'ipaNumber',
      label: 'IPA Number',
      sortable: true,
      order: 6
    },
    {
      key: 'insuranceContractNo',
      label: 'INS Contract No',
      sortable: true,
      order: 7
    },
    {
      key: 'plan',
      label: 'Plan',
      sortable: true,
      order: 8
    },
    {
      key: 'sex',
      label: 'Sex',
      sortable: true,
      order: 9
    },
    {
      key: 'dob',
      label: 'DOB',
      formatter: 'formatDate',
      sortable: true,
      order: 10
    },
    {
      key: 'patientStatus',
      label: 'Status',
      sortable: true,
      order: 11
    },
    {
      key: 'dXs',
      label: 'DXs',
      sortable: true,
      order: 12
    },
    {
      key: 'percentage_BFSM',
      label: '% Validated DXs - First Semester',
      formatter: (value: any) => {
        if (value) return (value * 100).toFixed(2) + '%'
      },
      format: '0.00%',
      sortable: true,
      order: 13
    },
    {
      key: 'percentage_BSSM',
      label: '% Validated DXs - Second Semester',
      formatter: (value: any) => {
        if (value == 0.0) return value
        if (value) return (value * 100).toFixed(2) + '%'
      },
      format: '0.00%',
      sortable: true,
      order: 14
    },
    {
      key: 'raF_TOTAL',
      label: 'Estimated Risk',
      formatter: (value: any) => {
        if (value) return value.toFixed(2)
      },
      sortable: true,
      order: 15
    },
    {
      key: 'recordID',
      label: 'Record ID',
      sortable: true,
      order: 16
    },
    {
      key: 'drRecordID',
      label: 'Dr. Record ID',
      sortable: true,
      order: 17
    },
    {
      key: 'recordDate',
      label: 'Record Date',
      formatter: 'formatDate',
      sortable: true,
      order: 18,
      format: 'd-mmm-yy'
    },
    {
      key: 'show_details',
      label: ''
    }
  ]
  public items: Patient[] = []
  public perPage = 10
  public pageOptions = [10, 20, 50, 100, 250, 500, 1000]
  public pagination = {} as PaginationVM
  public insurances: SelectVM[] = []
  public insurancesPlans: SelectVM[] = []
  public searchQuery = ''
  public showPending = false
  public contracts = [
    {
      text: '12345',
      value: 12345
    },
    {
      text: '125',
      value: 125
    }
  ]
  public userRole = ''
  public genders: SelectVM[] = []
  public form = {} as PatientVM
  public isEditing = false
  public currentUser = ''
  public showSearch = false
  public searchLabel = 'Patient Name, INS Contract No:'
  public selectedInsurance: SelectVM[] = []
  public selectedIPANumbers: SelectVM[] = []
  public ipaNumbers: SelectVM[] = []
  public ipaNumberList: InsuranceIPANumber[] = []
  /** Assigned InsuranceIPA labels for InsuranceSupervisor (create/edit assignments). */
  public supervisorAssignedIPAs: string[] = []
  public canChangeStatus = true
  public sheets = [{ name: 'SheetOne', data: [{ c: 2 }] }]
  $refs!: {
    mytable: BTable
  }
  @Watch('perPage')
  perPageChange() {
    this._getPatients()
  }
  @Watch('selectedInsurance', { deep: true })
  onSelectedInsuranceChange() {
    this.selectedIPANumbers = []
    this.refreshIpaOptions()
  }
  public async onPageChange(pageNumber: number) {
    await this._getPatients(pageNumber, this.searchQuery)
  }
  get _pagination() {
    return this.pagination
  }
  get showIpaFilter() {
    return (
      this.userRole === Role.Insurance ||
      this.userRole === Role.InsuranceSupervisor ||
      this.userRole === Role.Admin ||
      this.userRole === Role.Superuser
    )
  }
  get showIpaColumn() {
    return (
      this.userRole === Role.Insurance ||
      this.userRole === Role.InsuranceSupervisor ||
      this.userRole === Role.Admin ||
      this.userRole === Role.Superuser
    )
  }

  public onInsuranceSelect(option: SelectVM) {
    if (option._isDisabled) {
      this.selectedInsurance = this.getSelectedInsurances().filter(
        i => String(i.value) !== String(option.value)
      )
      this.$swal.fire({
        title: 'Access Denied',
        text:
          'This insurance provider is not included in your current license. Please contact support to upgrade your plan.',
        icon: 'warning'
      })
    }
  }
  public isInsuranceDisabled(item: SelectVM, prop: string): boolean {
    item._isDisabled = true
    if (this._getUserInsurancesID.some(c => item[prop] == c)) {
      item._isDisabled = false
    }
    return item._isDisabled
  }
  public rowClass(item) {
    return item.dXs === 0 ? 'text-danger' : ''
  }
  private getSelectedInsurances(): SelectVM[] {
    return this.selectedInsurance || []
  }
  private getInsuranceCsv(): string {
    // SP #InsurancesTbl has PRIMARY KEY(InsuranceID) — duplicates (e.g. 3,3) abort the proc.
    return [
      ...new Set(
        this.getSelectedInsurances()
          .map(i => String(i.value).trim())
          .filter(Boolean)
      )
    ].join(',')
  }
  private getIpaCsv(): string {
    return [
      ...new Set(
        (this.selectedIPANumbers || [])
          .map(i => String(i.value).trim())
          .filter(Boolean)
      )
    ].join(',')
  }
  private refreshIpaOptions() {
    let scopeIds = this.getInsuranceCsv()
      .split(',')
      .map(x => x.trim())
      .filter(x => x)
    // If no insurance selected, limit to the dropdown insurance list (role-scoped).
    if (!scopeIds.length && this.insuranceList?.length) {
      scopeIds = [
        ...new Set(this.insuranceList.map(i => String(i.value)).filter(Boolean))
      ]
    }
    const assignedIpa = new Set(this.supervisorAssignedIPAs || [])
    this.ipaNumbers = (this.ipaNumberList || [])
      .filter(c => {
        const inScope =
          scopeIds.length === 0 || scopeIds.includes(String(c.insuranceID))
        const assignedOk =
          assignedIpa.size === 0 || assignedIpa.has(c.insuranceIPA)
        return inScope && assignedOk
      })
      .map(c => ({
        label: c.insuranceIPA,
        value: c.insuranceIPA
      }))
  }
  private async loadIpaNumbers() {
    if (!this.showIpaFilter) return
    // Load full IPA catalog once; filter client-side by selected insurance.
    // Do NOT join _getUserInsurancesID (agreement rows → huge duplicate CSV;
    // SP @Insurance is also varchar(100)).
    if (!this.ipaNumberList.length) {
      const response = await getIPANumbers()
      this.ipaNumberList = response?.data || []
    }
    this.refreshIpaOptions()
  }
  public async exportTablePending() {
    const response = await getPatients(
      1,
      10,
      this.searchQuery,
      '',
      this.getInsuranceCsv(),
      'true',
      true,
      this.getIpaCsv()
    )
    let filtered = response.data

    const filtrarAmbosSemestres = filtered => {
      return filtered
        .filter(
          item =>
            (item.percentage_BFSM === 1 && item.dXs === 0) ||
            (item.percentage_BFSM < 1 && item.dXs > 0) ||
            (item.percentage_BSSM === 1 && item.dXs === 0) ||
            (item.percentage_BSSM < 1 && item.dXs > 0)
        )
        .sort((a, b) => a.dXs - b.dXs)
    }

    filtered = filtrarAmbosSemestres(filtered)

    const filtrarYOrdenar1sm = filtered => {
      return (
        filtered
          // 1. Filtrar por status activo
          // .filter(item => item.status === 'activo')

          // 2. Filtrar por:
          // - porcentaje diferente de 100
          // - o porcentaje igual a 100 pero con 0 diagnósticos
          .filter(
            filtered =>
              (filtered.percentage_BFSM >= 1 && filtered.dXs === 0) ||
              (filtered.percentage_BFSM < 1 && filtered.dXs > 0)
          )

          // 3. Ordenar por raF_TOTAL de mayor a menor
          .sort((a, b) => b.raF_TOTAL - a.raF_TOTAL)
      )
    }

    const filtrarYOrdenar2sm = filtered => {
      return (
        filtered
          // 1. Filtrar por status activo
          // .filter(item => item.status === 'activo')

          // 2. Filtrar por:
          // - porcentaje diferente de 100
          // - o porcentaje igual a 100 pero con 0 diagnósticos
          .filter(
            filtered =>
              (filtered.percentage_BSSM >= 1 && filtered.dXs === 0) ||
              (filtered.percentage_BSSM < 1 && filtered.dXs > 0)
          )

          // 3. Ordenar por raF_TOTAL de mayor a menor
          .sort((a, b) => b.raF_TOTAL - a.raF_TOTAL)
      )
    }

    const data = [
      {
        sheet: 'First Semester ',
        columns: [],
        content: []
      },
      {
        sheet: 'Second Semester',
        columns: [],
        content: []
      }
    ]

    data[0].columns = this.fields
      .map(c => {
        return {
          label: c.label,
          value: c.key,
          format: c.format
        }
      })
      .filter(
        c =>
          c.value != 'index' &&
          c.value != 'show_details' &&
          c.value != 'percentage_BSSM'
      )
    if (this.userRole === Role.Doctor) {
      data[0].columns = [
        { label: 'NPI', value: 'npi' },
        { label: 'Doctor Name', value: 'doctorFullName' }
      ].concat(data[0].columns)
    }
    data[0].content = filtrarYOrdenar1sm(filtered).map(c => {
      return {
        ...c,
        patientStatus: c.patientStatus ? 'Yes' : 'No',
        dob: this.formatDate(c.dob?.toString()),
        recordDate: this.formatDate(c.recordDate.toString()),
        ['raF_TOTAL']: c.raF_TOTAL?.toFixed(2),
        ['percentage_BFSM']: c.percentage_BFSM
        // ['percentage_BSSM']: c.percentage_BSSM
      }
    })

    data[1].columns = this.fields
      .map(c => {
        return {
          label: c.label,
          value: c.key,
          format: c.format
        }
      })
      .filter(
        c =>
          c.value != 'index' &&
          c.value != 'show_details' &&
          c.value != 'percentage_BFSM'
      )
    if (this.userRole === Role.Doctor) {
      data[1].columns = [
        { label: 'NPI', value: 'npi' },
        { label: 'Doctor Name', value: 'doctorFullName' }
      ].concat(data[1].columns)
    }
    data[1].content = filtrarYOrdenar2sm(filtered).map(c => {
      return {
        ...c,
        patientStatus: c.patientStatus ? 'Yes' : 'No',
        dob: this.formatDate(c.dob?.toString()),
        recordDate: this.formatDate(c.recordDate.toString()),
        ['raF_TOTAL']: c.raF_TOTAL?.toFixed(2),
        // ['percentage_BFSM']: (c.percentage_BFSM * 100).toFixed(2) + '%',
        ['percentage_BSSM']: c.percentage_BSSM
      }
    })

    const settings = {
      fileName: 'Pending RAF Validation Report', // Name of the resulting spreadsheet
      extraLength: 3, // A bigger number means that columns will be wider
      writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
      writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
      RTL: false // Display the columns from right-to-left (the default value is false)
    }

    xlsx(data, settings) // Will download the excel file

    // this.items = filtrarAmbosSemestres(this.items)
  }
  public async exportTable() {
    let items = []

    const response = await getPatients(
      1,
      999999,
      this.searchQuery,
      '',
      this.getInsuranceCsv(),
      '',
      true,
      this.getIpaCsv()
    )
    items = response.data

    // if (this.searchQuery || this.selectedInsurance) {
    //   const response = await getPatients(
    //     1,
    //     999999,
    //     this.searchQuery,
    //     this.selectedInsurance?.label || '',
    //     '',
    //     true
    //   )
    //   items = response.data
    // } else {
    //   const response = await getPatientsAll()
    //   items = response.data
    // }

    // console.log(items)
    const updatedArray = items.map(obj => {
      const newObj = {}
      // Sort the first array based on the order property
      this.fields.sort((a, b) => a.order - b.order)
      // Get the keys in the order specified by the first array
      const keys = this.fields.map(x => x.key).filter(c => c != 'index')
      // Sort the keys of the object
      keys.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          const label = this.fields.find(x => x.key === key).label
          newObj[label.toLowerCase()] = obj[key.toLowerCase()]
        }
      })
      return newObj
    })
    // console.log(updatedArray)
    const data = [
      {
        sheet: 'Patient List',
        columns: [],
        content: []
      }
    ]

    data[0].columns = this.fields
      .map(c => {
        return {
          label: c.label,
          value: c.key,
          format: c.format
        }
      })
      .filter(c => c.value != 'index')
    if (this.userRole === Role.Doctor) {
      data[0].columns = [
        { label: 'NPI', value: 'npi' },
        { label: 'Doctor Name', value: 'doctorFullName' }
      ].concat(data[0].columns)
      // data[0].columns.push()

      // this.fields = this.fields.map(c => {
      //   return {
      //     ...c,
      //     key: 'npi',
      //     label: 'NPI',
      //     order: 2,
      //     sortable: false
      //   }
      // })
    }
    data[0].content = items.map(c => {
      return {
        ...c,
        patientStatus: c.patientStatus ? 'Yes' : 'No',
        dob: this.formatDate(c.dob?.toString()),
        recordDate: this.formatDate(c.recordDate.toString()),
        ['raF_TOTAL']: c.raF_TOTAL?.toFixed(2),
        ['percentage_BFSM']: (c.percentage_BFSM * 100).toFixed(2) + '%',
        ['percentage_BSSM']: (c.percentage_BSSM * 100).toFixed(2) + '%'
        // npi: c.npi
      }
    })

    const settings = {
      fileName: 'Patient List', // Name of the resulting spreadsheet
      extraLength: 3, // A bigger number means that columns will be wider
      writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
      writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
      RTL: false // Display the columns from right-to-left (the default value is false)
    }

    xlsx(data, settings) // Will download the excel file
  }
  public async getResolve() {
    const userRole = getUserRole()
    const { insurances } = await getInsuranceAgreementsResolve()
    if (userRole === Role.Doctor || userRole === Role.DoctorStaff) {
      const doctorId =
        userRole === Role.DoctorStaff
          ? Number(getDoctorHeadId())
          : Number(getCurrentUser()?.rmtUserId)
      if (doctorId) {
        const assigned = await getDoctorInsurances(doctorId)
        if (assigned?.length) {
          await this.$store.dispatch('app/addUserInsurance', assigned)
        }
      }
      this.insuranceList = insurances
        .map(c => ({
          ...c,
          _isDisabled: this.isInsuranceDisabled(c, 'value')
        }))
        .sort((a, b) => Number(a._isDisabled) - Number(b._isDisabled))
    } else if (userRole === Role.Insurance) {
      // Only insurances assigned to this Insurance user (create/edit / RMT_InsuranceAndRMT_Users).
      let assignedIds = [
        ...new Set(
          (this._getUserInsurancesID || [])
            .map(id => String(id))
            .filter(Boolean)
        )
      ]
      if (!assignedIds.length) {
        const rmtUserId = Number(getUserRmtId())
        const assigned = rmtUserId ? await getUserInsurances(rmtUserId) : []
        assignedIds = [
          ...new Set(
            (assigned || []).map(a => String(a.insuranceID)).filter(Boolean)
          )
        ]
        if (assigned?.length) {
          await this.$store.dispatch('app/addUserInsurance', assigned)
        }
      }
      const idSet = new Set(assignedIds)
      this.insuranceList = (insurances || []).filter(c =>
        idSet.has(String(c.value))
      )
    } else if (userRole === Role.InsuranceSupervisor) {
      // Only insurances/IPAs assigned at create/edit (not the full catalog).
      const rmtUserId = Number(getUserRmtId())
      const assigned = rmtUserId
        ? await getInsuranceSupervisorInsurances(rmtUserId)
        : []
      const insuranceIds = new Set(
        (assigned || []).map(a => String(a.insuranceID))
      )
      this.supervisorAssignedIPAs = [
        ...new Set(
          (assigned || []).map(a => a.insuranceIPA).filter(Boolean) as string[]
        )
      ]
      this.insuranceList = (insurances || []).filter(c =>
        insuranceIds.has(String(c.value))
      )
    } else {
      this.insuranceList = insurances
    }
    await this.loadIpaNumbers()
  }
  public hideDoctorInfo() {
    this.fields = this.fields.filter(
      i => i.key !== 'npi' && i.key !== 'doctorFullName'
    )
  }
  /** Insurance roles: show Doctor Name; keep NPI hidden (Admin/Staff keep both). */
  public hideDoctorNpiOnly() {
    this.fields = this.fields.filter(i => i.key !== 'npi')
  }
  private applyRoleColumns() {
    // IPA Number: Insurance / InsuranceSupervisor / Admin / Superuser (table + Excel).
    if (!this.showIpaColumn) {
      this.fields = this.fields.filter(i => i.key !== 'ipaNumber')
    }
  }
  private async created() {
    this.currentUser = getCurrentUser()
    this.userRole = getUserRole()
    if (this.userRole === Role.Admin || this.userRole === Role.InsuranceStaff) {
      this.showSearch = true
      this.showPending = false
      this.searchLabel = 'NPI, Doctor Name, Patient Name, INS Contract No:'
    } else if (
      this.userRole === Role.Insurance ||
      this.userRole === Role.InsuranceSupervisor
    ) {
      this.hideDoctorNpiOnly()
    } else if (getUserRole() == Role.DoctorStaff) {
      this.currentUser = getHeadDoctor()
      this.currentUser.userName = this.currentUser.documentId
      // console.log(this.currentUser)
      this.hideDoctorInfo()
    } else {
      this.hideDoctorInfo()
    }
    this.applyRoleColumns()
    if (this.userRole === Role.InsuranceStaff) {
      this.canChangeStatus = false
    }
    if (this.userRole === Role.Doctor) {
      this.showPending = true
    }
    await Promise.all([this._getPatients(), this.getResolve()])
  }
  public prepareExcelData() {
    this.sheets.push()
  }
  public async filter() {
    await this._getPatients(1, this.searchQuery)
  }
  public async cleanFilter() {
    this.searchQuery = ''
    this.selectedInsurance = []
    this.selectedIPANumbers = []
    this.refreshIpaOptions()
    await this._getPatients(1, this.searchQuery)
  }
  private async _getPatients(pageNumber = 1, searchQuery = '') {
    try {
      // Both filters are independent: if the user picked Insurance and InsuranceIPA,
      // both CSVs must be sent to the SP (@Insurance + @InsuranceIPA).
      const insurances = this.getInsuranceCsv()
      const insuranceIPA = this.getIpaCsv()
      const response = await getPatients(
        pageNumber,
        this.perPage,
        searchQuery,
        '',
        insurances,
        '',
        false,
        insuranceIPA
      )
      this.items = Array.isArray(response?.data) ? response.data : []
      const paginationHeader = response?.headers?.['x-pagination']
      this.pagination = paginationHeader
        ? JSON.parse(paginationHeader)
        : ({} as PaginationVM)
    } catch (e) {
      this.items = []
      throw e
    }
  }
  public formatDate(value: string) {
    if (value) return moment(value).format('MM/DD/YYYY')
  }
  public showRecord(recordID: string) {
    this.$router.push({ name: 'RecordsView', params: { recordID } })
  }

  public edit(item: PatientVM) {
    this.form = item
    // console.log(item)
  }
  public async create(): Promise<void> {
    const isValid = await this.$refs.observer.validate()
    if (!isValid) {
      return
    }

    const obj = {
      ...this.form,
      insuranceName: this.insurances.find(
        c => c.value == this.form.insuranceName
      )?.label,
      insurancePlan: this.insurancesPlans.find(
        c => c.value == this.form.insurancePlan
      )?.label,
      sex: this.genders.find(c => c.value == this.form.sex)?.label
    } as PatientVM
    if (!this.isEditing) {
      // console.log(obj)
      await postPatient(obj)
      // console.log(response)
      // if (response.some(c => c.error)) return
    } else {
      await updatePatient(obj)
    }
    // this.isEditing = false
    this._getPatients()

    this.$root.$emit('bv::toggle::modal', 'modal', '#btnCreate')

    // else {
    //   if (!this.form.insuranceID) return

    //   const obj: UpdateInsurance = {
    //     insuranceID: this.form.insuranceID,
    //     insuranceName: this.form.insuranceName
    //   }
    //   if (!obj.insuranceName) {
    //     this.$bvToast.toast('Please specify an insurance name', {
    //       title: 'Error!',
    //       variant: 'warning',
    //       solid: true,
    //       toaster: 'b-toaster-bottom-right',
    //       autoHideDelay: 5000,
    //       appendToast: true
    //     })
    //     return
    //   }
    //   const response = await editInsurance(obj)
    //   if (response.some(c => c.error)) return
    // }

    // this.isEditing = false
    // await this._getInsurances()
  }
  public changeStatus(checked: boolean, item: Patient) {
    this.$swal
      .fire({
        title: 'Are you sure?',
        text: `This patient status will be set as ${
          checked ? 'Active' : 'Inactive'
        }`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm'
      })
      .then((result): void => {
        if (result.isConfirmed) {
          const obj: UpdatePatientStatus = {
            doctorId: item.doctorId,
            documentID: item.documentID,
            statusValue: checked,
            patientID: item.patientID
          }

          updatePatientStatus(obj).then(() => {
            this._getPatients()
          })
          this.$swal.fire(
            `${checked ? 'Activated' : 'Deactivated'}!`,
            `The patient has been ${
              checked ? 'Activated' : 'Deactivated'
            } successfully`,
            'success'
          )
        } else {
          item.patientStatus = !item.patientStatus
        }
      })
  }
}
